import { render, staticRenderFns } from "./Instructor.vue?vue&type=template&id=72a3d520&scoped=true&"
import script from "./Instructor?vue&type=script&lang=js&"
export * from "./Instructor?vue&type=script&lang=js&"
import style0 from "./Instructor.vue?vue&type=style&index=0&id=72a3d520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3d520",
  null
  
)

export default component.exports